import './src/styles/global.css';

// Redirect to custom 404 in development
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.capture('$pageview');
  }

  if (
    typeof window !== 'undefined' &&
    process.env.NODE_ENV === 'development' &&
    location.pathname === '/dev-404-page/'
  ) {
    // Get the actual 404 path from the query params
    const params = new URLSearchParams(location.search);
    const notFoundPath = params.get('path') || '/404/';

    // Navigate to the custom 404 page
    window.___navigate(notFoundPath.startsWith('/en/') ? '/en/404/' : '/pl/404/');
  }
};
